export const TEMPLATE_VERSION = {
    version1: 'v1',
    version2: 'v2',
};
